module.exports = __webpack_public_path__ + "static/img/noNum.5daed03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noNum.png
// module id = 7RMR
// module chunks = 0